import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import { NodeBadge } from "../Nodes/Components/Node";

export default NodeCatalogList;

function NodeCatalogList({ nodes, onSelect }) {
  return (
    <div className="space-y-4">
      {nodes.map((node) => {
        const {
          label,
          icon: Icon,
          color,
        } = NodeUIRegistry[node.type][node?.subType ?? "default"];

        return (
          <div
            key={node.type + (node.subType ?? "")}
            onClick={() => onSelect(node)}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-zinc-50 text-left border p-4 hover:cursor-pointer"
          >
            <div className="flex flex-col gap-y-2">
              <NodeBadge
                color={color}
                icon={<Icon className="size-4"/>}
                label={label}
              />
              {node.description && (
                <p className="text-xs text-zinc-500">{node.description}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
